const locationId = process.env.REACT_APP_SQ_LOCATION_ID;
const appId = process.env.REACT_APP_SQUARE_APP_ID;
 // Add this line to check the value of URL
export  {locationId, appId};
